<template>
  <div class="footer-container " data-radium="true"
    style="width: 100%; font-size: 0.14rem; background: rgba(0, 0, 0, 0.5); padding: 0.3rem 0px;">
    <div class="footer-row 0" data-radium="true" style=" margin: auto auto 0.1rem;">
      <div class="footer-column-container  footer-provider" data-radium="true" style="width: 170%; margin-left: auto;">
        <div class="footer-list-container container gx-0" data-radium="true" style="display: flex; flex-wrap: wrap;">
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <p data-radium="true"
                style="color: rgb(255, 255, 255); background: red; position: absolute; font-size: 0.1rem; padding: 0.02rem 0px; border-radius: 0.1rem; width: 0.25rem; text-align: center; top: -0.05rem; right: 0px;">
                Hot
              </p>
              <img loading="lazy" src="/static/img/landing/SpadeGaming.png" class="provider" alt="SpadeGaming"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true"></div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/MicroGamingPlus.png" class="provider" alt="MicroGamingPlus"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/TTG.png" class="provider" alt="TTG"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/AsiaGaming2.png" class="provider" alt="AsiaGaming2"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/Habanero.png" class="provider" alt="Habanero"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/Allbet2.png" class="provider" alt="Allbet2"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <p data-radium="true"
                style="color: rgb(255, 255, 255); background: red; position: absolute; font-size: 0.1rem; padding: 0.02rem 0px; border-radius: 0.1rem; width: 0.25rem; text-align: center; top: -0.05rem; right: 0px;">
                Hot
              </p>
              <img loading="lazy" src="/static/img/landing/DreamGaming.png" class="provider" alt="DreamGaming"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <p data-radium="true"
                style="color: rgb(255, 255, 255); background: red; position: absolute; font-size: 0.1rem; padding: 0.02rem 0px; border-radius: 0.1rem; width: 0.25rem; text-align: center; top: -0.05rem; right: 0px;">
                Hot
              </p>
              <img loading="lazy" src="/static/img/landing/Evo.png" class="provider" alt="Evo"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <p data-radium="true"
                style="color: rgb(255, 255, 255); background: red; position: absolute; font-size: 0.1rem; padding: 0.02rem 0px; border-radius: 0.1rem; width: 0.25rem; text-align: center; top: -0.05rem; right: 0px;">
                Hot
              </p>
              <img loading="lazy" src="/static/img/landing/SexyBaccarat2.png" class="provider" alt="SexyBaccarat2"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/PragmaticPlay.png" class="provider" alt="PragmaticPlay"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/PlayNGo.png" class="provider" alt="PlayNGo"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/EBET.png" class="provider" alt="EBET"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/SAGaming.png" class="provider" alt="SAGaming"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/KingMaker.png" class="provider" alt="KingMaker"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/WMCasino.png" class="provider" alt="WMCasino"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/PGSoft.png" class="provider" alt="PGSoft"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/FunkyGames.png" class="provider" alt="FunkyGames"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/Joker.png" class="provider" alt="Joker"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/NETENT.png" class="provider" alt="NETENT"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/JILI.png" class="provider" alt="JILI"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/RedTiger.png" class="provider" alt="RedTiger"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/CQ9.png" class="provider" alt="CQ9"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
          <div class="list-item" data-radium="true" style="position: relative;">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/FaChai.png" class="provider" alt="FaChai"
                style="width: 100%; margin: 0px 0px 0.17rem; padding: 0px 0.05rem; height: 0.6rem;" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-row 2" data-radium="true" style=" margin: auto;">
      <div class="footer-column-container  footer-custom" data-radium="true"
        style="width: 100%; border: 0.01rem solid rgb(36, 28, 39); margin: 0.2rem 0px;"></div>
    </div>
    <div class="footer-row 3" data-radium="true" style=" margin: auto; display: flex; justify-content: center;">
      <div class="footer-column-container  footer-payment-method" data-radium="true"
        style="padding: 0.3rem 10px 0px 0px;">
        <p class="fcol-title" data-radium="true"
          style="font-size: 0.14rem; margin: 0px 0px 0.15rem; color: rgb(255, 255, 255); text-align: center;">
          <span>วิธีการชำระเงิน</span>
        </p>
        <div class="footer-list-container " data-radium="true" style="display: flex; flex-wrap: wrap;">
          <div class="list-item" data-radium="true">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/EeziePay.png" class="payment-method" alt="EeziePay"
                style="height: 0.38rem; margin: 0px 4px 0px 0px;" />
            </div>
          </div>
          <div class="list-item" data-radium="true">
            <div class="" data-radium="true">
              <img loading="lazy" src="/static/img/landing/Help2Pay.png" class="payment-method" alt="Help2Pay"
                style="height: 0.38rem; margin: 0px 4px 0px 0px;" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-row 5" data-radium="true" style="margin: auto auto 0.1rem;">
      <div class="footer-column-container  footer-custom" data-radium="true"
        style="width: 100%; border: 0.01rem solid rgb(36, 28, 39);"></div>
    </div>
    <div class="footer-row 6" data-radium="true" style=" margin: 0.2rem auto; display: flex; justify-content: center;">
      <div class="footer-column-container  footer-copyright" data-radium="true"
        style="text-align: center; display: flex;">
        <div class="copyrightColumn" data-radium="true">
          <div data-radium="true">
            <div class="copyrightContent" data-radium="true"
              style="color: rgb(255, 255, 255); align-items: center; font-size: 0.14rem; margin-top: 0.02rem;">
              สงวนลิขสิทธิ์ GODPLAY46 © 2023. สงวนลิขสิทธิ์.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import CashBackForm from '@/components/form/CashBackForm'
import PromotionForm from '@/components/form/PromotionForm'
import WheelForm from '@/components/form/WheelForm'
import AfForm from '@/components/form/AfForm'
import WithdrawForm from '@/components/form/WithdrawForm'
import DepositForm from '@/components/form/DepositForm'
import HistoryForm from '@/components/form/HistoryForm'
import ProfileForm from '@/components/form/ProfileForm'
import MemberCard from '@/components/form/MemberCard'
export default {
  name: 'Footer',
  data() {
    return {
      isShowNav: true,
      nowPage: this.$route.name,
    }
  },
  components: {
    CashBackForm,
    PromotionForm,
    WheelForm,
    AfForm,
    WithdrawForm,
    DepositForm,
    HistoryForm,
    ProfileForm,
    MemberCard,
  },
  computed: {
    ...mapGetters(['getLineId', 'appTitle']),
  },
  methods: {
    ...mapActions(['userSignIn', 'setError']),
    gotoRoute(route) {
      this.$router.push(route)
    },
  },
  watch: {
    $route() {
      this.nowPage = this.$route.name
      this.isShowNav = true
      if (
        this.$route.name == 'Login' ||
        this.$route.name == 'Profile' ||
        this.$route.name == 'Signup' ||
        this.$route.name == 'Join'
      ) {
        return (this.isShowNav = false)
      }
    },
  },
  mounted() {
    this.nowPage = this.$route.name
  },
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue